import type { MessageContext } from '@intlify/core-base'

import { normalizeKey } from './app/util/normalizeKey'

export const i18nDefaults = {
  i18n: {
    addcard: ({ linked }: MessageContext) => {
      const onlyDebitCardsAllowed = useIsFeatureFlagEnabled('onlyDebitCardsAllowed')

      return onlyDebitCardsAllowed
        ? linked('i18n.internal.adddebitcard')
        : linked('i18n.internal.addcard')
    },
    card: ({ linked }: MessageContext) => {
      const onlyDebitCardsAllowed = useIsFeatureFlagEnabled('onlyDebitCardsAllowed')

      return onlyDebitCardsAllowed
        ? linked('i18n.internal.card')
        : linked('i18n.internal.debitcard')
    },
    countryname: () => `${useRuntimeConfig().public.i18nConfig.countryName}`,
    gamblinghotline: () => `${useRuntimeConfig().public.i18nConfig.gamblingHotline}`,
    playnow: ({ linked }: MessageContext) => {
      const lt = normalizeKey(useRuntimeConfig().public.licensedTerritory)
      const path = 'i18n.internal.playnow'
      const pathWithLt = `${path}.${lt}`

      return linked(pathWithLt) === pathWithLt ? linked(path) : linked(pathWithLt)
    },
    requiredage: () => `${useRuntimeConfig().public.i18nConfig.requiredAge}`,
    shopname: () => `${useRuntimeConfig().public.i18nConfig.shopPublicName}`,
    statename: () => `${useRuntimeConfig().public.i18nConfig.stateName}`,
  },
}
